var _defs, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{isolation:isolate;}.cls-5{clip-path:url(#clip-path-3);}.cls-6{clip-path:url(#clip-path-4);}.cls-7{clip-path:url(#clip-path-5);}.cls-8{clip-path:url(#clip-path-6);}.cls-9{clip-path:url(#clip-path-7);}.cls-10{clip-path:url(#clip-path-8);}.cls-11{clip-path:url(#clip-path-9);}.cls-12{clip-path:url(#clip-path-10);}.cls-13{clip-path:url(#clip-path-11);}.cls-14{clip-path:url(#clip-path-12);}.cls-15{clip-path:url(#clip-path-13);}.cls-16{clip-path:url(#clip-path-14);}.cls-17{clip-path:url(#clip-path-15);}.cls-18{clip-path:url(#clip-path-16);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.81,22.72H5.91A5.92,5.92,0,0,1,0,16.81V5.91A5.92,5.92,0,0,1,5.91,0h10.9a5.92,5.92,0,0,1,5.91,5.91v10.9A5.92,5.92,0,0,1,16.81,22.72ZM5.91,4A1.91,1.91,0,0,0,4,5.91v10.9a1.92,1.92,0,0,0,1.91,1.91h10.9a1.91,1.91,0,0,0,1.91-1.91V5.91A1.9,1.9,0,0,0,16.81,4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.56,214.84H-450.78V-853.4H151.56Zm-598.34-4H147.56V-849.4H-446.78Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.78,72.83H-50.29V-49.24H71.78Zm-118.07-4H67.78V-45.24H-46.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.91,23.37H-.83V-1.37H23.91Zm-20.74-4H19.91V2.63H3.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.37,50H5.46A5.92,5.92,0,0,1-.45,44.09V33.19a5.92,5.92,0,0,1,5.91-5.91H16.37a5.91,5.91,0,0,1,5.9,5.91v10.9A5.91,5.91,0,0,1,16.37,50ZM5.46,31.28a1.92,1.92,0,0,0-1.91,1.91v10.9A1.91,1.91,0,0,0,5.46,46H16.37a1.9,1.9,0,0,0,1.9-1.91V33.19a1.91,1.91,0,0,0-1.9-1.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.11,219.57H-451.22V-848.67H151.11Zm-598.33-4H147.11V-844.67H-447.22Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.33,99.9H-50.74V-22.17H71.33Zm-118.07-4H67.33V-18.17H-46.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.47,50.44H-1.27V25.69H23.47Zm-20.74-4H19.47V29.69H2.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.09,22.72H33.19a5.92,5.92,0,0,1-5.91-5.91V5.91A5.92,5.92,0,0,1,33.19,0h10.9A5.92,5.92,0,0,1,50,5.91v10.9A5.92,5.92,0,0,1,44.09,22.72ZM33.19,4a1.91,1.91,0,0,0-1.91,1.91v10.9a1.92,1.92,0,0,0,1.91,1.91h10.9A1.91,1.91,0,0,0,46,16.81V5.91A1.9,1.9,0,0,0,44.09,4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.62,214.84H-445.71V-853.4H156.62Zm-598.33-4H152.62V-849.4H-441.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.19,72.83H-22.89V-49.24H99.19Zm-118.08-4H95.19V-45.24H-18.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.32,23.37H26.58V-1.37H51.32Zm-20.74-4H47.32V2.63H30.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.09,50H33.19a5.92,5.92,0,0,1-5.91-5.91V33.19a5.92,5.92,0,0,1,5.91-5.91h10.9A5.92,5.92,0,0,1,50,33.19v10.9A5.92,5.92,0,0,1,44.09,50ZM33.19,31.28a1.92,1.92,0,0,0-1.91,1.91v10.9A1.91,1.91,0,0,0,33.19,46h10.9A1.9,1.9,0,0,0,46,44.09V33.19a1.91,1.91,0,0,0-1.91-1.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.62,219.57H-445.71V-848.67H156.62Zm-598.33-4H152.62V-844.67H-441.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.19,99.9H-22.89V-22.17H99.19Zm-118.08-4H95.19V-18.17H-18.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.32,50.44H26.58V25.69H51.32Zm-20.74-4H47.32V29.69H30.58Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.81,22.72H5.91A5.92,5.92,0,0,1,0,16.81V5.91A5.92,5.92,0,0,1,5.91,0h10.9a5.92,5.92,0,0,1,5.91,5.91v10.9A5.92,5.92,0,0,1,16.81,22.72ZM5.91,4A1.91,1.91,0,0,0,4,5.91v10.9a1.92,1.92,0,0,0,1.91,1.91h10.9a1.91,1.91,0,0,0,1.91-1.91V5.91A1.9,1.9,0,0,0,16.81,4Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.56,214.84H-450.78V-853.4H151.56Zm-598.34-4H147.56V-849.4H-446.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.78,72.83H-50.29V-49.24H71.78Zm-118.07-4H67.78V-45.24H-46.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.91,23.37H-.83V-1.37H23.91Zm-20.74-4H19.91V2.63H3.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.81,22.72H5.91A5.92,5.92,0,0,1,0,16.81V5.91A5.92,5.92,0,0,1,5.91,0h10.9a5.92,5.92,0,0,1,5.91,5.91v10.9A5.92,5.92,0,0,1,16.81,22.72ZM5.91,4A1.91,1.91,0,0,0,4,5.91v10.9a1.92,1.92,0,0,0,1.91,1.91h10.9a1.91,1.91,0,0,0,1.91-1.91V5.91A1.9,1.9,0,0,0,16.81,4Z"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.37,50H5.46A5.92,5.92,0,0,1-.45,44.09V33.19a5.92,5.92,0,0,1,5.91-5.91H16.37a5.91,5.91,0,0,1,5.9,5.91v10.9A5.91,5.91,0,0,1,16.37,50ZM5.46,31.28a1.92,1.92,0,0,0-1.91,1.91v10.9A1.91,1.91,0,0,0,5.46,46H16.37a1.9,1.9,0,0,0,1.9-1.91V33.19a1.91,1.91,0,0,0-1.9-1.91Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.11,219.57H-451.22V-848.67H151.11Zm-598.33-4H147.11V-844.67H-447.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.33,99.9H-50.74V-22.17H71.33Zm-118.07-4H67.33V-18.17H-46.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.47,50.44H-1.27V25.69H23.47Zm-20.74-4H19.47V29.69H2.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.37,50H5.46A5.92,5.92,0,0,1-.45,44.09V33.19a5.92,5.92,0,0,1,5.91-5.91H16.37a5.91,5.91,0,0,1,5.9,5.91v10.9A5.91,5.91,0,0,1,16.37,50ZM5.46,31.28a1.92,1.92,0,0,0-1.91,1.91v10.9A1.91,1.91,0,0,0,5.46,46H16.37a1.9,1.9,0,0,0,1.9-1.91V33.19a1.91,1.91,0,0,0-1.9-1.91Z"
  }))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.09,22.72H33.19a5.92,5.92,0,0,1-5.91-5.91V5.91A5.92,5.92,0,0,1,33.19,0h10.9A5.92,5.92,0,0,1,50,5.91v10.9A5.92,5.92,0,0,1,44.09,22.72ZM33.19,4a1.91,1.91,0,0,0-1.91,1.91v10.9a1.92,1.92,0,0,0,1.91,1.91h10.9A1.91,1.91,0,0,0,46,16.81V5.91A1.9,1.9,0,0,0,44.09,4Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.62,214.84H-445.71V-853.4H156.62Zm-598.33-4H152.62V-849.4H-441.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.19,72.83H-22.89V-49.24H99.19Zm-118.08-4H95.19V-45.24H-18.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.32,23.37H26.58V-1.37H51.32Zm-20.74-4H47.32V2.63H30.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.09,22.72H33.19a5.92,5.92,0,0,1-5.91-5.91V5.91A5.92,5.92,0,0,1,33.19,0h10.9A5.92,5.92,0,0,1,50,5.91v10.9A5.92,5.92,0,0,1,44.09,22.72ZM33.19,4a1.91,1.91,0,0,0-1.91,1.91v10.9a1.92,1.92,0,0,0,1.91,1.91h10.9A1.91,1.91,0,0,0,46,16.81V5.91A1.9,1.9,0,0,0,44.09,4Z"
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.09,50H33.19a5.92,5.92,0,0,1-5.91-5.91V33.19a5.92,5.92,0,0,1,5.91-5.91h10.9A5.92,5.92,0,0,1,50,33.19v10.9A5.92,5.92,0,0,1,44.09,50ZM33.19,31.28a1.92,1.92,0,0,0-1.91,1.91v10.9A1.91,1.91,0,0,0,33.19,46h10.9A1.9,1.9,0,0,0,46,44.09V33.19a1.91,1.91,0,0,0-1.91-1.91Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.62,219.57H-445.71V-848.67H156.62Zm-598.33-4H152.62V-844.67H-441.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.19,99.9H-22.89V-22.17H99.19Zm-118.08-4H95.19V-18.17H-18.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.32,50.44H26.58V25.69H51.32Zm-20.74-4H47.32V29.69H30.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.09,50H33.19a5.92,5.92,0,0,1-5.91-5.91V33.19a5.92,5.92,0,0,1,5.91-5.91h10.9A5.92,5.92,0,0,1,50,33.19v10.9A5.92,5.92,0,0,1,44.09,50ZM33.19,31.28a1.92,1.92,0,0,0-1.91,1.91v10.9A1.91,1.91,0,0,0,33.19,46h10.9A1.9,1.9,0,0,0,46,44.09V33.19a1.91,1.91,0,0,0-1.91-1.91Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.ee0162207fd2c537b33106ebde82d095.svg";
export { ForwardRef as ReactComponent };